import { Component } from '@angular/core';

@Component({
  selector: 'app-moon-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './moon-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class MoonIconComponent {}
